import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../../shared/spinner';
import { Produto } from '../../../shared/model/produto';
import ProdutoService from '../../../services/produtoService';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';
import ResponsivePagination from 'react-responsive-pagination';
import { Esteira } from '../../../shared/model/esteira';
import { FiltroProdutoDTO } from '../../../shared/dto/produtoDTO';
import { ButtonAlterar } from '../../../shared/buttons';
import { TiposProduto, getLabelTipoProduto, EnumTipoProduto } from '../../../shared/constantes/tiposProduto';
import EsteiraModeloService from '../../../services/esteiraModeloService';
import { ProtectedAction } from '../../../AccessControl';

function ProdutoComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const produtoService = new ProdutoService();
  const esteiraModeloService: EsteiraModeloService = new EsteiraModeloService();

  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [esteiras, setEsteiras] = useState<Esteira[]>([]);
  const [loading, setLoading] = useState(true);
  const [filtrosAtivos, setFiltrosAtivos] = useState(false);

  const [codigo, setCodigo] = useState('');
  const [nome, setNome] = useState('');
  const [tipoProduto, setTipoProduto] = useState<string>(''); // só string
  const [codigoExterno, setCodigoExterno] = useState('');
  const [esteiraId, setEsteiraId] = useState<number | ''>('');

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { REACT_APP_PERFIL } = process.env;

  const perfil = REACT_APP_PERFIL;

  const listarEsteiras = async () => {
    try {
      const response = await esteiraModeloService.listarEsteirasModeloAtivas();
      setEsteiras(response.data);
    } catch (error) {
      console.error('Erro ao listar esteiras:', error);
    }
  };

  const listarProdutos = async (pagina = currentPage, tamanho = pageSize) => {
    setLoading(true);

    const filtro = new FiltroProdutoDTO();
    filtro.id = codigo ? Number(codigo) : undefined;
    filtro.nome = nome || undefined;
    filtro.tipoProduto = tipoProduto ? (TiposProduto.find(tp => tp.value === tipoProduto)?.value) : undefined;
    filtro.codigoExterno = codigoExterno || undefined;
    filtro.idEsteira = typeof esteiraId === 'number' ? esteiraId : undefined;

    try {
      const response = await produtoService.listarTodosProdutosFiltro(pagina, tamanho, filtro);
      setProdutos(response.data.content);
      setTotalPages(response.data.totalPages);
      setCurrentPage(pagina);
    } catch (err) {
      console.error('Erro ao buscar produtos:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    listarProdutos(0, pageSize);
    listarEsteiras();
  }, []);

  const isTipoProdutoValido = (value: string) => {
    return Object.values(EnumTipoProduto).includes(value as any);
  };

  return (
    <div className="position-relative m-md-3">
      <div className="d-flex justify-content-between mb-3">
        <h5>Parâmetros Cartão &gt; Produto</h5>
        <ProtectedAction>
          <Button
            id="App-button-cor-principal-escura"
            onClick={() => navigate('/parametros-produto/inclusao', { state: { id: null } })}
          >
            + Novo Produto
          </Button>
        </ProtectedAction>  
      </div>

      <div className="d-flex justify-content-between mb-2">
        <Button
          id="App-button-cor-principal-escura"
          onClick={() => setFiltrosAtivos(!filtrosAtivos)}
        >
          <FontAwesomeIcon icon={faFilter} className="me-2" />
          Filtros
        </Button>
      </div>

      {filtrosAtivos && (
        <>
          <Row className="mb-4">
            <Form.Group as={Col} md="2">
              <Form.Label>Código</Form.Label>
              <Form.Control value={codigo} onChange={(e) => setCodigo(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label>Nome</Form.Label>
              <Form.Control value={nome} onChange={(e) => setNome(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label>Tipo Produto</Form.Label>
              <Form.Select
                value={tipoProduto}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '' || isTipoProdutoValido(val)) {
                    setTipoProduto(val);
                  }
                }}
              >
                <option value="">Todos</option>
                {TiposProduto.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="3">
              <Form.Label>Código Externo</Form.Label>
              <Form.Control value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Form.Label>Esteira</Form.Label>
              <Form.Select
                value={esteiraId === '' ? '' : esteiraId}
                onChange={(e) => {
                  const val = e.target.value;
                  setEsteiraId(val ? parseInt(val) : '');
                }}
              >
                <option value="">Todas</option>
                 {esteiras.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nomeEsteira}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
          <div className="mb-3">
            <Button
              id="App-button-cor-principal-escura"
              onClick={() => listarProdutos(0, pageSize)}
            >
              <FontAwesomeIcon icon={faRefresh} className="me-2" />
              Aplicar Filtros
            </Button>
          </div>
        </>
      )}

      <Row className="mb-3 justify-content-center">
        <Form.Group as={Col} md="2" className="mt-2">
          Registros por Página
        </Form.Group>
        <Form.Group as={Col} md="1">
          <Form.Select
            value={pageSize}
            onChange={(e) => {
              const newSize = parseInt(e.target.value);
              setPageSize(newSize);
              listarProdutos(0, newSize);
            }}
          >
            {[10, 20, 30, 50, 100].map((qtd) => (
              <option key={qtd} value={qtd}>
                {qtd}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Row>

      {loading ? (
        <Spinner loading={loading} />
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th id="App-header-table">Código</th>
                <th id="App-header-table">Nome</th>
                <th id="App-header-table">Tipo Produto</th>
                <th id="App-header-table">Código Externo</th>
                <th id="App-header-table">Esteira</th>
                <ProtectedAction>
                  <th id="App-header-table">Alteração</th>
                </ProtectedAction>
              </tr>
            </thead>
            <tbody>
              {produtos.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.nome}</td>
                  <td>{getLabelTipoProduto(item.tipoProduto)}</td>
                  <td>{perfil === "QISTA" ? item.codigoMotor.toString().padStart(6, "0") : item.codigoMotor }</td>
                  <td>
                    {item.esteira.id} - {item.esteira.nomeEsteira}
                  </td>
                  <ProtectedAction>
                    <td>
                      <Link to="/parametros-produto/alteracao" state={{ id: item.id }}>
                        <ButtonAlterar />
                      </Link>
                    </td>
                  </ProtectedAction>
                </tr>
              ))}
            </tbody>
          </table>

          <ResponsivePagination
            current={currentPage}
            total={totalPages}
            onPageChange={(page) => listarProdutos(page, pageSize)}
          />
        </div>
      )}
    </div>
  );
}

export default ProdutoComponent;
